import { Injectable, inject } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';

import { IRegion } from '@app/common/interfaces';


@Injectable({
  providedIn: 'root',
})
export class RegionData<T = any> {
  private _api = inject(FsApi);


  public create(data: IRegion = { id: null }): IRegion {
    data.regionStates = data.regionStates || [];

    return data;
  }

  public get(id: number, query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.get(
      `regions/${id}`,
      query,
      {
        key: 'region',
        ...config,
      },
    );
  }

  public gets(query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.request(
      'GET',
      'regions',
      query,
      {
        key: 'regions',
        ...config,
      },
    );
  }

  public regionStates(query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.request(
      'GET',
      'regionstates',
      query,
      {
        key: 'regionStates',
        ...config,
      },
    );
  }

  public defaultStates(query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.request(
      'GET',
      'regions/states/default',
      query,
      {
        key: 'states',
        ...config,
      },
    );
  }

  public put(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.put(
      `regions/${data.id}`,
      data,
      {
        key: 'region',
        ...config,
      },
    );
  }

  public post(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      'regions',
      data,
      {
        key: 'region',
        ...config,
      },
    );
  }

  public delete(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.delete(
      `regions/${data.id}`,
      data,
      {
        key: 'region',
        ...config,
      },
    );
  }

  public save(data: any): Observable<T> {
    return (data.id)
      ? this.put(data)
      : this.post(data);
  }

}
